/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilesystemTraceEndpointRequest
 */
export interface FilesystemTraceEndpointRequest {
    /**
     * 
     * @type {number}
     * @memberof FilesystemTraceEndpointRequest
     */
    duration: number;
}

export function FilesystemTraceEndpointRequestFromJSON(json: any): FilesystemTraceEndpointRequest {
    return FilesystemTraceEndpointRequestFromJSONTyped(json, false);
}

export function FilesystemTraceEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilesystemTraceEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'duration': json['duration'],
    };
}

export function FilesystemTraceEndpointRequestToJSON(value?: FilesystemTraceEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'duration': value.duration,
    };
}


